// @flow
import { connect } from "react-redux";

import { dismissNotification } from "../actions/Notification";

import type { ReduxState, DismissNotificationAction } from "../types";
import type { MessageObject } from "../../i18n/types";
import type ErrorResponse from "../../models/error/ErrorResponse";
import type { ComponentType } from "react";

type StateProps = {
  messageType: string | null,
  message: MessageObject | null,
  error: ?ErrorResponse,
  render: boolean,
};

type DispatchProps = {
  onDismiss: () => DismissNotificationAction,
};

type Props = {
  ...StateProps,
  ...DispatchProps,
};

const mapStateToProps = (state: ReduxState): StateProps => ({
  messageType: state.notification.messageType,
  message: state.notification.message,
  error: state.notification.error,
  render: state.notification.render,
});

const mapDispatchToProps = {
  onDismiss: dismissNotification,
};

/**
 * @deprecated - will be removed in the future, use the equivalent hook 'useNotification' instead
 */
export const connectNotification: ComponentType<any> = connect<
  Props,
  {},
  StateProps,
  _,
  _,
  _,
>(mapStateToProps, mapDispatchToProps);
